import { dashboardConstants } from "../constants/dashboard.constants";

const initState = {
    dashboard: null,
    exhibitionState: null
};

export function dashboardReducer(state = initState, action) {
    switch (action.type) {
        case dashboardConstants.DASHBOARD_STORE_SUCCESS:
            return {
                ...state,
                dashboard: action.dashboardModel
            };
        case dashboardConstants.DASHBOARD_STORE_FAILURE:
            return {
                ...state,
                dashboard: null,
            };
        case dashboardConstants.DASHBOARD_STORE_CLEAR:
            return {
                ...state,
                dashboard: null,
            };
        case dashboardConstants.EXHIBITION_STATE_SUCCESS:
            return  {
                ...state,
                exhibitionState: action.exhibitionState
            };
        case dashboardConstants.EXHIBITION_STATE_FAILURE:
            return  {
                ...state,
                exhibitionState: null
            };
        default:
            return state
    };
}
